type TrackEventParams = {
  eventAction?: string;
  eventLabel?: string;
  eventCategory?: string;
  subscription_package?: string;
  subscription_period?: string;
  subscription_source?: string;
};

const trackEvent = ({ eventAction = '', eventLabel = '', ...rest }: TrackEventParams) => {
  if (eventAction || eventLabel) {
    const event = Object.entries(rest).reduce<Record<string, string>>(
      (acc, [key, value]) => (value ? { ...acc, [key]: value } : acc),
      { eventAction, eventLabel },
    );
    if (window.ecGa) {
      window.ecGa('trackEvent', event);
    }
  }
};

export default trackEvent;
